module.exports = __webpack_public_path__ + "img/user_header_bg.f184a2d2.jpg";